/* Zuatu scroll journey.
   Scroll position is a camera: every chapter flies from a vanishing point at the centre of the stage,
   settles in focus, then passes the lens. The camera only ever moves forward, so there is no seam to
   reverse across. Each product gets a HOLD (a stretch of scroll where it sits perfectly still, copy
   fully in) and the TRAVEL between holds is eased, so the camera decelerates into every stop. If the
   visitor stops scrolling mid-travel, the page glides to the nearest stop. Reduced-motion users (and no-JS) keep the stacked layout; colourway swatches work in both. */
(function () {
  'use strict';
  var root = document.querySelector('[data-zj]');
  if (!root) return;

  /* ── colourway swatches (static + live) ── */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.zj-swatch') : null;
    if (!btn) return;
    var ch = btn.closest('[data-zj-ch]');
    var idx = +btn.getAttribute('data-zj-v');
    var shoes = ch.querySelectorAll('.zj-art > .zj-shoe');
    for (var i = 0; i < shoes.length; i++) shoes[i].classList.toggle('is-on', i === idx);
    var buys = ch.querySelectorAll('[data-zj-buy]');
    for (var j = 0; j < buys.length; j++) buys[j].hidden = +buys[j].getAttribute('data-zj-buy') !== idx;
    var sw = ch.querySelectorAll('.zj-swatch');
    for (var k = 0; k < sw.length; k++) sw[k].setAttribute('aria-pressed', String(k === idx));
  });

  /* alternate colourways are display:none, so lazy never fires: warm them once the page is idle */
  var warm = function () {
    var alts = root.querySelectorAll('.zj-art > .zj-shoe:not(.is-on)');
    for (var i = 0; i < alts.length; i++) alts[i].loading = 'eager';
  };
  if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 3000 }); else setTimeout(warm, 1500);

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !(window.CSS && CSS.supports && CSS.supports('position', 'sticky'))) return;

  var runway = root.querySelector('[data-zj-runway]');
  var stage = root.querySelector('[data-zj-stage]');
  var rail = root.querySelector('[data-zj-rail]');
  var wrap = root.querySelector('[data-zj-chapters]');
  var bar = root.querySelector('[data-zj-bar]');
  var els = Array.prototype.slice.call(root.querySelectorAll('[data-zj-ch]'));
  var N = els.length;
  if (N < 2) return;
  root.classList.add('zj--live');

  /* stacked = art above copy in one column (phones, portrait tablets); keep in sync with the CSS query */
  var STACKED = window.matchMedia('(max-width: 760px), (max-width: 1100px) and (orientation: portrait)');
  var KIND = { shoe: 0.15, plate: 0.21, intro: 0.2, final: 0.2, shelf: 0 };
  var S0 = 0.16;
  var clamp = function (x, a, b) { return Math.min(b === undefined ? 1 : b, Math.max(a === undefined ? 0 : a, x)); };
  var sm = function (a, b, x) { x = clamp((x - a) / (b - a)); return x * x * (3 - 2 * x); };
  var mix = function (a, b, m) { return a + (b - a) * m; };
  var hex = function (h) {
    h = h.replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  };

  var chs = els.map(function (el, i) {
    var kind = (el.className.match(/zj-ch--(intro|final|shelf|plate|shoe)/) || [])[1] || 'shoe';
    return {
      el: el, i: i, kind: kind, last: i === N - 1,
      side: +el.getAttribute('data-side') || 1,
      art: el.querySelector('[data-zj-art]'),
      ghost: el.querySelector('[data-zj-ghost]'),
      copy: el.querySelector('[data-zj-copy]'),
      bg: hex(el.getAttribute('data-bg')), ink: hex(el.getAttribute('data-ink')),
      near: false, focus: false, bx: 0, by: 0, enter: 0
    };
  });
  var lum = function (c) { return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255; };
  chs.forEach(function (c, i) {
    /* a big light<->dark jump gets its own earlier window, and the new copy waits for it */
    c.jump = i > 0 && Math.abs(lum(c.bg) - lum(chs[i - 1].bg)) > 0.5;
    c.enter = c.jump ? 0.2 : 0;
  });

  /* rail */
  var ticks = chs.map(function (c) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'zj__tick';
    b.innerHTML = '<span>' + c.el.getAttribute('data-label') + '</span><i aria-hidden="true"></i>';
    b.addEventListener('click', function () { goTo(c.i); });
    rail.appendChild(b);
    return b;
  });

  var vw, vh, hold, travel, seg, pageTop, small, cur = 0, target = 0, running = false, activeIdx = -1, lastW = 0;

  function measure() {
    vw = window.innerWidth; vh = window.innerHeight; small = STACKED.matches;
    hold = vh * (small ? 0.38 : 0.45);   /* scroll distance a product stays perfectly still */
    travel = vh * (small ? 0.72 : 0.8);  /* scroll distance to fly to the next one */
    seg = hold + travel;
    runway.style.height = ((N - 1) * seg + hold + vh) + 'px';
    pageTop = runway.getBoundingClientRect().top + window.pageYOffset;
    var cx = vw / 2, cy = wrap.clientHeight / 2;
    chs.forEach(function (c) {
      c.rx = small ? 0 : KIND[c.kind] * vw * c.side;
      if (!c.art) return;
      /* where the art rests (layout position, transforms ignored) vs. the vanishing point */
      c.bx = cx - (c.art.offsetLeft + c.art.offsetWidth / 2);
      c.by = cy - (c.art.offsetTop + c.art.offsetHeight / 2);
    });
  }

  /* scroll offset inside the runway -> camera time t (integer t = a product at rest) */
  function tOf(y) {
    if (y <= 0) return 0;
    var k = Math.floor(y / seg);
    if (k >= N - 1) return N - 1;
    var r = y - k * seg;
    if (r < hold) return k;
    return k + 0.5 - 0.5 * Math.cos(Math.PI * (r - hold) / travel);
  }

  function readTarget() {
    target = tOf(window.pageYOffset - pageTop);
  }

  function frame(t) {
    var i0 = Math.min(N - 2, Math.floor(t)), f = t - i0;
    var a = chs[i0], b = chs[i0 + 1];
    var m = b.jump ? sm(0.4, 0.78, f) : sm(0.58, 0.94, f);
    stage.style.setProperty('--zj-bg', 'rgb(' + [0, 1, 2].map(function (k) { return Math.round(mix(a.bg[k], b.bg[k], m)); }).join(',') + ')');
    stage.style.setProperty('--zj-ink', 'rgb(' + [0, 1, 2].map(function (k) { return Math.round(mix(a.ink[k], b.ink[k], m)); }).join(',') + ')');
    bar.style.transform = 'scaleX(' + (t / (N - 1)).toFixed(4) + ')';

    chs.forEach(function (c) {
      var p = t - c.i;
      var near = p > -1.04 && (c.last || p < 0.8);
      if (near !== c.near) { c.near = near; c.el.classList.toggle('is-near', near); }
      if (!near) return;

      var s, o, x, y, r, gs, go, v, u;
      if (p < 0) {
        u = clamp(1 + p);
        s = S0 * Math.pow(1 / S0, u);
        o = sm(0, 0.42, u);
        x = c.bx * (1 - u) + c.rx * u;
        y = c.by * (1 - u);
        r = c.side * -8 * (1 - u);
        gs = 0.45 + 0.55 * u; go = sm(0.1, 0.7, u);
      } else if (c.last) {
        s = 1; o = 1; x = c.rx; y = 0; r = 0; gs = 1; go = 1;
      } else {
        v = clamp(p);
        s = 1 + 1.05 * Math.pow(v, 1.1);
        o = 1 - sm(0.1, 0.6, v);
        x = c.rx + c.side * vw * 0.22 * v;
        y = -vh * 0.05 * v;
        r = c.side * 5 * v;
        gs = 1 + 2.6 * Math.pow(v, 1.15); go = 1 - sm(0.05, 0.65, v);
      }
      if (c.art) {
        c.art.style.opacity = o.toFixed(3);
        c.art.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + r.toFixed(2) + 'deg) scale(' + s.toFixed(4) + ')';
      }
      if (c.ghost) {
        c.ghost.style.opacity = go.toFixed(3);
        c.ghost.style.transform = 'translate3d(0,-50%,0) scale(' + gs.toFixed(4) + ')';
      }
      if (c.copy) {
        /* a delayed entrance must still finish before the stop (p = 0), or the copy rests half-faded */
        var co = sm(-0.5 + c.enter, Math.min(-0.14 + c.enter, -0.03), p) * (c.last ? 1 : 1 - sm(0.12, 0.46, p));
        var dy = (1 - sm(-0.5 + c.enter, Math.min(-0.1 + c.enter, -0.03), p)) * 34 - (c.last ? 0 : sm(0.08, 0.46, p) * 26);
        c.copy.style.opacity = co.toFixed(3);
        c.copy.style.transform = 'translate3d(0,' + dy.toFixed(1) + 'px,0)';
        var foc = co > 0.55;
        if (foc !== c.focus) { c.focus = foc; c.el.classList.toggle('is-focus', foc); }
      }
    });

    var idx = Math.round(t);
    if (idx !== activeIdx) {
      activeIdx = idx;
      ticks.forEach(function (b, k) {
        if (k === idx) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
      });
    }
  }

  function tick() {
    var k = small ? 0.2 : 0.13;
    var d = target - cur;
    if (Math.abs(d) < 0.0007) { cur = target; frame(cur); running = false; return; }
    cur += d * k;
    frame(cur);
    requestAnimationFrame(tick);
  }
  function kick() { if (!running) { running = true; requestAnimationFrame(tick); } }

  function goTo(i) {
    window.scrollTo({ top: Math.round(pageTop + i * seg + hold / 2), behavior: 'smooth' });
  }

  /* settle: stopped between two products -> glide to the one the visitor was heading for */
  var idle = 0, lastY = window.pageYOffset, dir = 1, touching = false;
  function settle() {
    if (touching) return;
    var y = window.pageYOffset - pageTop;
    if (y <= 0 || y >= (N - 1) * seg) return; /* outside the journey: leave the page alone */
    var k = Math.floor(y / seg), r = y - k * seg;
    if (r < hold) return; /* already resting on a product */
    var u = (r - hold) / travel;
    var fwd = dir > 0 ? u > 0.3 : u > 0.7;
    var to = fwd ? (k + 1) * seg + hold * 0.3 : k * seg + hold * 0.7;
    window.scrollTo({ top: Math.round(pageTop + to), behavior: 'smooth' });
  }

  window.addEventListener('scroll', function () {
    var y = window.pageYOffset;
    if (y !== lastY) dir = y > lastY ? 1 : -1;
    lastY = y;
    readTarget(); kick();
    clearTimeout(idle);
    idle = setTimeout(settle, small ? 240 : 180);
  }, { passive: true });
  window.addEventListener('touchstart', function () { touching = true; clearTimeout(idle); }, { passive: true });
  window.addEventListener('touchend', function () { touching = false; clearTimeout(idle); idle = setTimeout(settle, 240); }, { passive: true });
  window.addEventListener('resize', function () {
    var w = window.innerWidth;
    if (w === lastW) return; /* ignore URL-bar-only height changes on touch */
    lastW = w; measure(); readTarget(); cur = target; frame(cur);
  });
  window.addEventListener('orientationchange', function () { setTimeout(function () { lastW = 0; window.dispatchEvent(new Event('resize')); }, 200); });
  window.addEventListener('load', function () { measure(); readTarget(); cur = target; frame(cur); });

  var start = root.querySelector('[data-zj-start]');
  if (start) start.addEventListener('click', function (e) { e.preventDefault(); goTo(1); });

  lastW = window.innerWidth;
  measure(); readTarget(); cur = target; frame(cur);
})();
